import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { get } from 'lodash';
import App from '.';

class Root extends HTMLElement {
  public static defaultVisibleApps = 'summary, profile';
  public static defaultCombineWithPatientStore = 'false';

  constructor() {
    super();
  }

  static get observedAttributes() {
    return ['visible-apps', 'combine-with-patient-store'];
  }

  public attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (oldValue === newValue) {
      return;
    }
    switch (name) {
      case 'visible-apps':
        this.setAttribute('visible-apps', newValue);
        this.render();
        break;
      case 'combine-with-patient-store':
        this.setAttribute('combine-with-patient-store', newValue);
        this.render();
        break;
    }
  }

  get visibleApps() {
    return this.getAttribute('visible-apps') || Root.defaultVisibleApps;
  }

  set visibleApps(newValue: string) {
    this.setAttribute('visible-apps', newValue);
  }

  get combineWithPatientStore() {
    return this.getAttribute('combine-with-patient-store') || Root.defaultCombineWithPatientStore;
  }

  set combineWithPatientStore(newValue: string) {
    this.setAttribute('combine-with-patient-store', newValue);
  }

  public connectedCallback() {
    this.render();
  }

  public disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }

  public render() {
    ReactDOM.render(
      <App
        getStore={get(window, 'patientCommons.store.injectAsyncReducer', (o: any) => o)}
        visibleApps={this.visibleApps}
        combineWithPatientStore={this.combineWithPatientStore}
      />,
      this,
    );

    if (process.env.NODE_ENV !== 'production' && !(window as any).__patient_sidebar__render__once__) {
      (window as any).__patient_sidebar__render__once__ = true;
      (window as any).__patient_sidebar__base__path__ = this.getAttribute('basePath');
    }
  }
}

// useful in dev mode
// define only if element is not available already
if (!customElements.get('patient-sidebar')) {
  customElements.define('patient-sidebar', Root);
} else {
  const elem = document.querySelector('patient-sidebar');
  ReactDOM.render(
    <App
      getStore={get(window, 'patientCommons.store.injectAsyncReducer', (o: any) => o)}
      visibleApps={get(elem, 'visible-apps', Root.defaultVisibleApps)}
      combineWithPatientStore={get(elem, 'combine-with-patient-store', Root.defaultCombineWithPatientStore)}
    />,
    elem,
  );
}

if (process.env.NODE_ENV !== 'production' && (window as any).__patient_sidebar__render__once__) {
  // only for hot reloading with engine
}

// require('../hmr');

export default Root;
